/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { StartDate } from './';
import {
    StartDateFromJSON,
    StartDateFromJSONTyped,
    StartDateToJSON,
} from './';
import type { StartDateType } from './';
import {
    StartDateTypeFromJSON,
    StartDateTypeFromJSONTyped,
    StartDateTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface UnknownStartDate
 */
export interface UnknownStartDate extends StartDate {
}

/**
 * Check if a given object implements the UnknownStartDate interface.
 */
export function instanceOfUnknownStartDate(value: object): value is UnknownStartDate {
    return true;
}

export function UnknownStartDateFromJSON(json: any): UnknownStartDate {
    return UnknownStartDateFromJSONTyped(json, false);
}

export function UnknownStartDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnknownStartDate {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...StartDateFromJSONTyped(json, ignoreDiscriminator),
    };
}

export function UnknownStartDateToJSON(value?: UnknownStartDate | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...StartDateToJSON(value, true),
    };
}

